/**
 * @remix-run/cloudflare-workers v1.2.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { sign, unsign } from './cookieSigning.js';

function installGlobals() {
  self.sign = sign;
  self.unsign = unsign;
}

export { installGlobals };
